export const GET_PROJECT_LEAD_ALL_ACT = "GET_PROJECT_LEAD_ALL_ACT"
export const GET_PROJECT_LEAD_ALL_ACT_SUCCESS = "GET_PROJECT_LEAD_ALL_ACT_SUCCESS"
export const GET_PROJECT_LEAD_ALL_ACT_FAIL = "GET_PROJECT_LEAD_ALL_ACT_FAIL"

export const ADD_PROJECT_LEAD_NOTE = "ADD_PROJECT_LEAD_NOTE"
export const ADD_PROJECT_LEAD_NOTE_SUCCESS = "ADD_PROJECT_LEAD_NOTE_SUCCESS"
export const ADD_PROJECT_LEAD_NOTE_FAIL = "ADD_PROJECT_LEAD_NOTE_FAIL"

export const GET_PROJECT_LEAD_NOTE = "GET_PROJECT_LEAD_NOTE"
export const GET_PROJECT_LEAD_NOTE_SUCCESS = "GET_LEAD_NOTE_SUCCESS"
export const GET_PROJECT_LEAD_NOTE_FAIL = "GET_LEAD_NOTE_FAIL"


export const ADD_PROJECT_LEAD_FOLLOW = "ADD_PROJECT_LEAD_FOLLOW"
export const ADD_PROJECT_LEAD_FOLLOW_SUCCESS = "ADD_PROJECT_LEAD_FOLLOW_SUCCESS"
export const ADD_PROJECT_LEAD_FOLLOW_FAIL = "ADD_PROJECT_LEAD_FOLLOW_FAIL"

export const GET_PROJECT_LEAD_FOLLOW = "GET_PROJECT_LEAD_FOLLOW"
export const GET_PROJECT_LEAD_FOLLOW_SUCCESS = "GET_PROJECT_LEAD_FOLLOW_SUCCESS"
export const GET_PROJECT_LEAD_FOLLOW_FAIL = "GET_PROJECT_LEAD_FOLLOW_FAIL"


export const ADD_PROJECT_LEAD_CALLLOG = "ADD_PROJECT_LEAD_CALLLOG"
export const ADD_PROJECT_LEAD_CALLLOG_SUCCESS = "ADD_PROJECT_LEAD_CALLLOG_SUCCESS"
export const ADD_PROJECT_LEAD_CALLLOG_FAIL = "ADD_PROJECT_LEAD_CALLLOG_FAIL"


export const GET_PROJECT_LEAD_CALLLOG = "GET_PROJECT_LEAD_CALLLOG"
export const GET_PROJECT_LEAD_CALLLOG_SUCCESS = "GET_PROJECT_LEAD_CALLLOG_SUCCESS"
export const GET_PROJECT_LEAD_CALLLOG_FAIL = "GET_PROJECT_LEAD_CALLLOG_FAIL"


export const ADD_PROJECT_LEAD_EMAILLOG = "ADD_LEAD_EMAILLOG"
export const ADD_PROJECT_LEAD_EMAILLOG_SUCCESS = "ADD_TAB_EMAIL_SUCCESS"
export const ADD_PROJECT_LEAD_EMAILLOG_FAIL = "ADD_TAB_EMAIL_FAIL"

export const GET_PROJECT_LEAD_EMAILLOG = "GET_PROJECT_LEAD_EMAILLOG"
export const GET_PROJECT_LEAD_EMAILLOG_SUCCESS = "GET_PROJECT_LEAD_EMAILLOG_SUCCESS"
export const GET_PROJECT_LEAD_EMAILLOG_FAIL = "GET_PROJECT_LEAD_EMAILLOG_FAIL"


export const ADD_ACTIVITY_FOLLOW_UP = "ADD_ACTIVITY_FOLLOW_UP"
export const ADD_ACTIVITY_FOLLOW_UP_SUCCESS = "ADD_ACTIVITY_FOLLOW_UP_SUCCESS"
export const ADD_ACTIVITY_FOLLOW_UP_FAIL = "ADD_ACTIVITY_FOLLOW_UP_FAIL"


export const GET_ACTIVITY_FOLLOW_UP = "GET_ACTIVITY_FOLLOW_UP"
export const GET_ACTIVITY_FOLLOW_UP_SUCCESS = "GET_ACTIVITY_FOLLOW_UP_SUCCESS"
export const GET_ACTIVITY_FOLLOW_UP_FAIL = "GET_ACTIVITY_FOLLOW_UP_FAIL"


export const ADD_ACTIVITY_PROJECT_FOLLOW_UP = "ADD_ACTIVITY_PROJECT_FOLLOW_UP"
export const ADD_ACTIVITY_PROJECT_FOLLOW_UP_SUCCESS = "ADD_ACTIVITY_PROJECT_FOLLOW_UP_SUCCESS"
export const ADD_ACTIVITY_PROJECT_FOLLOW_UP_FAIL = "ADD_ACTIVITY_PROJECT_FOLLOW_UP_FAIL"


export const GET_ACTIVITY_PROJECT_FOLLOW_UP = "GET_ACTIVITY_PROJECT_FOLLOW_UP"
export const GET_ACTIVITY_PROJECT_FOLLOW_UP_SUCCESS = "GET_ACTIVITY_PROJECT_FOLLOW_UP_SUCCESS"
export const GET_ACTIVITY_PROJECT_FOLLOW_UP_FAIL = "GET_ACTIVITY_PROJECT_FOLLOW_UP_FAIL"



export const ADD_CONTACT_ACTIVITY_FOLLOW_UP = "ADD_CONTACT_ACTIVITY_FOLLOW_UP"
export const ADD_CONTACT_ACTIVITY_FOLLOW_UP_SUCCESS = "ADD_CONTACT_ACTIVITY_FOLLOW_UP_SUCCESS"
export const ADD_CONTACT_ACTIVITY_FOLLOW_UP_FAIL = "ADD_ACTIVITY_FOLLOW_UP_FAIL"


export const GET_CONTACT_ACTIVITY_FOLLOW_UP = "GET_CONTACT_ACTIVITY_FOLLOW_UP"
export const GET_CONTACT_ACTIVITY_FOLLOW_UP_SUCCESS = "GET_CONTACT_ACTIVITY_FOLLOW_UP_SUCCESS"
export const GET_CONTACT_ACTIVITY_FOLLOW_UP_FAIL = "GET_CONTACT_ACTIVITY_FOLLOW_UP_FAIL"

